"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleDaiManager = void 0;
var player_base_1 = require("@24i/player-base");
var player_plugin_ssai_1 = require("@24i/player-plugin-ssai");
var DaiSdk_1 = require("../DaiSdk");
var toMilliseconds = function (timeOffset, duration) {
    if (typeof timeOffset !== 'number')
        return -1;
    if (Number.isFinite(timeOffset)) {
        return timeOffset < 0 ? -1 : timeOffset * 1000;
    }
    return Number.isFinite(duration) && duration > 0 ? duration : Infinity;
};
var GoogleDaiManager = (function (_super) {
    __extends(GoogleDaiManager, _super);
    function GoogleDaiManager(videoElement, adContainer, player) {
        var _this = _super.call(this, player) || this;
        _this.daiSdk = null;
        _this.streamManager = null;
        _this.source = null;
        _this.liveAdBreakStart = NaN;
        _this.liveAdStart = NaN;
        _this.liveAd = null;
        _this.cuePoints = [];
        _this.timingCorrections = [];
        _this.stateCorrections = [];
        _this.videoElement = videoElement;
        _this.adContainer = adContainer;
        _this.onPlayerMetadata = _this.onPlayerMetadata.bind(_this);
        return _this;
    }
    GoogleDaiManager.prototype.canLoad = function (source) {
        var _a;
        return ((_a = source.ssai) === null || _a === void 0 ? void 0 : _a.type) === 'googledai';
    };
    GoogleDaiManager.prototype.load = function (source) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1, uiSettings, ssai, streamRequest, liveRequest, vodRequest, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4, DaiSdk_1.loadSdk()];
                    case 1:
                        _a.daiSdk = _c.sent();
                        return [3, 3];
                    case 2:
                        error_1 = _c.sent();
                        throw new player_base_1.PlayerError({
                            code: player_base_1.ErrorCodes.PLAYER_SOURCE_UNAVAILABLE,
                            message: 'Google DAI SDK not loaded',
                            nativeCode: error_1,
                        });
                    case 3:
                        uiSettings = new this.daiSdk.UiSettings();
                        this.streamManager = new this.daiSdk.StreamManager(this.videoElement, this.adContainer, uiSettings);
                        this.streamManager.addEventListener(this.daiSdk.StreamEvent.Type.LOADED, function (event) { return _this.onDaiLoaded(event.getStreamData()); });
                        this.streamManager.addEventListener(this.daiSdk.StreamEvent.Type.ERROR, function (event) { return _this.onDaiLoaded(event.getStreamData()); });
                        this.streamManager.addEventListener(this.daiSdk.StreamEvent.Type.CUEPOINTS_CHANGED, function (event) { return _this.onDaiCuePoints(event.getStreamData().cuepoints); });
                        this.streamManager.addEventListener(this.daiSdk.StreamEvent.Type.AD_BREAK_STARTED, function (event) { return _this.onDaiBreakStarted(event.getAd()); });
                        this.streamManager.addEventListener(this.daiSdk.StreamEvent.Type.STARTED, function (event) { return _this.onDaiStarted(event.getAd()); });
                        this.streamManager.addEventListener(this.daiSdk.StreamEvent.Type.SKIPPED, function () { return _this.onDaiSkipped(); });
                        this.streamManager.addEventListener(this.daiSdk.StreamEvent.Type.COMPLETE, function () { return _this.onDaiCompleted(); });
                        this.streamManager.addEventListener(this.daiSdk.StreamEvent.Type.AD_BREAK_ENDED, function () { return _this.onDaiBreakEnded(); });
                        this.player.addEventListener('metadata', this.onPlayerMetadata);
                        ssai = source.ssai;
                        if (ssai.live) {
                            liveRequest = new this.daiSdk.LiveStreamRequest();
                            liveRequest.assetKey = ssai.assetKey;
                            streamRequest = liveRequest;
                        }
                        else {
                            vodRequest = new this.daiSdk.VODStreamRequest();
                            vodRequest.contentSourceId = ssai.contentSourceId;
                            vodRequest.videoId = ssai.videoId;
                            streamRequest = vodRequest;
                        }
                        streamRequest.adTagParameters = ssai.adTagParameters;
                        streamRequest.apiKey = ssai.apiKey;
                        streamRequest.authToken = ssai.authToken;
                        if (source.mimeType === player_base_1.MIME_TYPE.DASH ||
                            source.mimeType === player_base_1.MIME_TYPE.MPEG_DASH) {
                            streamRequest.format = 'dash';
                        }
                        else if (source.mimeType === player_base_1.MIME_TYPE.HLS ||
                            source.mimeType === player_base_1.MIME_TYPE.M3U8) {
                            streamRequest.format = 'hls';
                        }
                        _b = this;
                        return [4, new Promise(function (resolve, reject) {
                                _this.source = source;
                                _this.resolveLoad = resolve;
                                _this.rejectLoad = reject;
                                _this.streamManager.requestStream(streamRequest);
                            })];
                    case 4:
                        _b.source = _c.sent();
                        return [2, _super.prototype.load.call(this, this.source)];
                }
            });
        });
    };
    GoogleDaiManager.prototype.onPlayerMetadata = function (event) {
        var streamManager = this.streamManager;
        if (!streamManager)
            return;
        var type = event.type, time = event.time, value = event.value;
        if (type === 'TXXX' && typeof value === 'string') {
            streamManager.onTimedMetadata({
                TXXX: value,
            });
        }
        else if (type.startsWith('urn:google:dai:') || type === 'ID3') {
            streamManager.processMetadata(type, value, time);
        }
    };
    GoogleDaiManager.prototype.unload = function () {
        var _a;
        _super.prototype.unload.call(this);
        (_a = this.streamManager) === null || _a === void 0 ? void 0 : _a.reset();
        this.player.removeEventListener('metadata', this.onPlayerMetadata);
        this.source = null;
        this.streamManager = undefined;
        this.cuePoints = [];
        this.timingCorrections = [];
        this.stateCorrections = [];
        this.liveAdBreakStart = NaN;
        this.liveAdStart = NaN;
        this.liveAd = null;
    };
    GoogleDaiManager.prototype.onDaiLoaded = function (streamData) {
        var _a;
        var _b = this, resolveLoad = _b.resolveLoad, rejectLoad = _b.rejectLoad;
        if (!resolveLoad || !rejectLoad)
            return;
        this.resolveLoad = null;
        this.rejectLoad = null;
        if (streamData.url) {
            var originalSubtitles = (_a = this.source.textTracks) !== null && _a !== void 0 ? _a : [];
            var mappedSubtitles = streamData.subtitles.map(function (subtitle) {
                return ({
                    url: subtitle.url,
                    language: subtitle.language,
                    label: subtitle.language_name,
                });
            });
            var finalSource = __assign(__assign({}, this.source), { url: streamData.url, textTracks: __spreadArray(__spreadArray([], originalSubtitles), mappedSubtitles) });
            resolveLoad(finalSource);
        }
        else {
            var errorMessage = streamData.errorMessage || 'Google DAI failed to provide URL';
            rejectLoad(new player_base_1.PlayerError({
                code: player_base_1.ErrorCodes.PLAYER_SOURCE_UNAVAILABLE,
                message: errorMessage,
            }));
        }
    };
    GoogleDaiManager.prototype.onDaiCuePoints = function (cuePoints) {
        this.cuePoints = cuePoints;
        var duration = this.player.duration;
        this.timingCorrections = cuePoints.map(function (cuePoint) {
            return toMilliseconds(cuePoint.end, duration);
        });
        if (this.stateCorrections.length === 0) {
            this.stateCorrections = cuePoints.map(function (cuePoint) {
                return cuePoint.played
                    ? player_base_1.ITimelineEventPlayed.PLAYED
                    : player_base_1.ITimelineEventPlayed.UNPLAYED;
            });
        }
        this.updateAdvertisements();
    };
    GoogleDaiManager.prototype.onDaiBreakStarted = function (ad) {
        if (!ad)
            return;
        this.liveAdBreakStart = this.player.currentTime;
        this.liveAd = ad;
        this.updateAdvertisements();
    };
    GoogleDaiManager.prototype.onDaiStarted = function (ad) {
        if (!ad)
            return;
        this.liveAdStart = this.player.currentTime;
        this.liveAd = ad;
        var nearest = this.findNearestCuePoint(function (c) { return c.start; });
        if (nearest) {
            this.stateCorrections[nearest.index] =
                player_base_1.ITimelineEventPlayed.PLAYING_UNSKIPPABLE;
        }
        this.updateAdvertisements();
    };
    GoogleDaiManager.prototype.onDaiSkipped = function () {
        var nearest = this.findNearestCuePoint(function (c) { return c.end; });
        if (nearest) {
            this.stateCorrections[nearest.index] = player_base_1.ITimelineEventPlayed.SKIPPED;
        }
    };
    GoogleDaiManager.prototype.onDaiCompleted = function () {
        var nearest = this.findNearestCuePoint(function (c) { return c.end; });
        if (nearest) {
            this.timingCorrections[nearest.index] = this.player.currentTime;
            this.stateCorrections[nearest.index] = player_base_1.ITimelineEventPlayed.PLAYED;
        }
    };
    GoogleDaiManager.prototype.findNearestCuePoint = function (extractor) {
        var _a = this.player, currentTime = _a.currentTime, duration = _a.duration;
        return this.cuePoints
            .map(function (cuePoint, index) {
            var distanceMs = Math.abs(toMilliseconds(extractor(cuePoint), duration) - currentTime);
            return {
                cuePoint: cuePoint,
                index: index,
                distanceMs: distanceMs,
            };
        })
            .reduce(function (previous, current) {
            return previous && previous.distanceMs < current.distanceMs
                ? previous
                : current;
        }, null);
    };
    GoogleDaiManager.prototype.onDaiBreakEnded = function () {
        this.liveAdBreakStart = NaN;
        this.liveAdStart = NaN;
        this.liveAd = null;
        this.updateAdvertisements();
    };
    GoogleDaiManager.prototype.getAdvertisements = function () {
        var _this = this;
        if (this.cuePoints.length > 0) {
            return this.cuePoints.map(function (cuePoint, index) {
                return _this.buildCuedAdvertisement(index, cuePoint);
            });
        }
        var liveAdvertisement = this.buildLiveAdvertisement();
        return liveAdvertisement ? [liveAdvertisement] : [];
    };
    GoogleDaiManager.prototype.buildCuedAdvertisement = function (index, cuePoint) {
        var liveAd = this.liveAd;
        var duration = this.player.duration;
        var start = toMilliseconds(cuePoint.start, duration);
        var startUtc = this.getUtcTime(start, player_base_1.SeekType.CURRENT_TIME);
        var end = toMilliseconds(cuePoint.end, duration);
        var endUtc = this.getUtcTime(end, player_base_1.SeekType.CURRENT_TIME);
        var earlyEnd = this.timingCorrections[index];
        var played = this.stateCorrections[index];
        var liveAdPodInfo = liveAd === null || liveAd === void 0 ? void 0 : liveAd.getAdPodInfo();
        var liveAdTimeOffset = liveAdPodInfo === null || liveAdPodInfo === void 0 ? void 0 : liveAdPodInfo.getTimeOffset();
        if (typeof liveAdTimeOffset !== 'number') {
            liveAd = null;
        }
        else if (liveAdTimeOffset < 0) {
            var finalPodDuration = toMilliseconds(Math.max(liveAdPodInfo.getMaxDuration(), liveAd.getDuration(), 0));
            var finalPodOffset = duration - finalPodDuration;
            if (start < finalPodOffset) {
                liveAd = null;
            }
        }
        else if (Math.abs(cuePoint.start - liveAdTimeOffset) > 0.1) {
            liveAd = null;
        }
        var name = liveAd === null || liveAd === void 0 ? void 0 : liveAd.getTitle();
        var skipOffset = liveAd === null || liveAd === void 0 ? void 0 : liveAd.getSkipTimeOffset();
        if (!liveAd ||
            !liveAd.isSkippable() ||
            !Number.isFinite(skipOffset) ||
            skipOffset < 0) {
            skipOffset = null;
        }
        else {
            skipOffset = toMilliseconds(skipOffset) + start;
        }
        var skipOffsetUtc = this.getUtcTime(skipOffset, player_base_1.SeekType.CURRENT_TIME);
        var dataIncomplete = !liveAd;
        var embeddedUi = played !== player_base_1.ITimelineEventPlayed.PLAYED &&
            played !== player_base_1.ITimelineEventPlayed.SKIPPED;
        return {
            type: player_base_1.ISourceTimelineEventType.ADVERTISEMENT,
            name: name,
            start: start,
            startUtc: startUtc,
            end: end,
            endUtc: endUtc,
            earlyEnd: earlyEnd,
            skipOffset: skipOffset,
            skipOffsetUtc: skipOffsetUtc,
            played: played,
            canSkip: false,
            canRestart: false,
            adBreak: {
                adBreakIndex: index,
                adBreakOffset: start,
                totalAds: 1,
            },
            ad: {
                adBreakIndex: index,
                adPosition: 0,
                skipOffset: skipOffset,
                duration: end - start,
                title: name !== null && name !== void 0 ? name : '',
                description: '',
                inStreamAdvertisement: true,
                embeddedUi: embeddedUi,
                canRestart: false,
            },
            dataIncomplete: dataIncomplete,
        };
    };
    GoogleDaiManager.prototype.buildLiveAdvertisement = function () {
        var liveAd = this.liveAd;
        if (!liveAd)
            return null;
        var adStart = this.liveAdStart;
        var adBreakStart = this.liveAdBreakStart;
        if (!Number.isFinite(adStart)) {
            if (!Number.isFinite(adBreakStart))
                return null;
            adStart = adBreakStart;
        }
        if (!Number.isFinite(adBreakStart)) {
            adBreakStart = adStart;
        }
        var adDuration;
        var adPodInfo = liveAd.getAdPodInfo();
        if (!adPodInfo) {
            adDuration = toMilliseconds(liveAd.getDuration());
        }
        else if (adPodInfo.getMaxDuration() > 0) {
            adDuration = toMilliseconds(adPodInfo.getMaxDuration());
        }
        else {
            adDuration = toMilliseconds(liveAd.getDuration());
        }
        var adEnd = adStart + adDuration;
        var adTitle = liveAd.getTitle();
        var skipOffset;
        if (!liveAd.isSkippable()) {
            skipOffset = null;
        }
        else if (liveAd.getSkipTimeOffset() < 0) {
            skipOffset = null;
        }
        else {
            skipOffset = adStart + toMilliseconds(liveAd.getSkipTimeOffset());
        }
        return {
            type: player_base_1.ISourceTimelineEventType.ADVERTISEMENT,
            name: adTitle,
            start: adStart,
            startUtc: this.getUtcTime(adStart, player_base_1.SeekType.CURRENT_TIME),
            end: adEnd,
            endUtc: this.getUtcTime(adEnd, player_base_1.SeekType.CURRENT_TIME),
            skipOffset: skipOffset,
            skipOffsetUtc: this.getUtcTime(skipOffset, player_base_1.SeekType.CURRENT_TIME),
            played: player_base_1.ITimelineEventPlayed.PLAYING_UNSKIPPABLE,
            canSkip: false,
            adBreak: {
                adBreakIndex: 0,
                adBreakOffset: adBreakStart,
                totalAds: 1,
            },
            ad: {
                adBreakIndex: 0,
                adPosition: 0,
                skipOffset: skipOffset,
                duration: adDuration,
                title: adTitle,
                description: '',
                inStreamAdvertisement: true,
                embeddedUi: true,
            },
        };
    };
    return GoogleDaiManager;
}(player_plugin_ssai_1.BaseSsaiManager));
exports.GoogleDaiManager = GoogleDaiManager;
//# sourceMappingURL=index.js.map